import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import AddRoadIcon from '@mui/icons-material/AddRoad';
import AddToHomeScreenIcon from '@mui/icons-material/AddToHomeScreen';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import AirportShuttleIcon from '@mui/icons-material/AirportShuttle';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowLeftSharpIcon from '@mui/icons-material/ArrowLeftSharp';
import ArrowRightSharpIcon from '@mui/icons-material/ArrowRightSharp';
import AutoModeIcon from '@mui/icons-material/AutoMode';
import BadgeIcon from '@mui/icons-material/Badge';
import BusinessIcon from '@mui/icons-material/Business';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CloseIcon from '@mui/icons-material/Close';
import ConstructionIcon from '@mui/icons-material/Construction';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import DeleteIcon from '@mui/icons-material/Delete';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import DevicesFoldIcon from '@mui/icons-material/DevicesFold';
import DoneIcon from '@mui/icons-material/Done';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import EditIcon from '@mui/icons-material/Edit';
import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import EditNoteIcon from '@mui/icons-material/EditNote';
import EditRoadIcon from '@mui/icons-material/EditRoad';
import EmailIcon from '@mui/icons-material/Email';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import EuroIcon from '@mui/icons-material/Euro';
import EventIcon from '@mui/icons-material/Event';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import FreeCancellationIcon from '@mui/icons-material/FreeCancellation';
import HelpIcon from '@mui/icons-material/Help';
import ImageIcon from '@mui/icons-material/Image';
import InfoSharpIcon from '@mui/icons-material/InfoSharp';
import KeyboardArrowDownSharpIcon from '@mui/icons-material/KeyboardArrowDownSharp';
import KeyboardArrowRightSharpIcon from '@mui/icons-material/KeyboardArrowRightSharp';
import LightModeIcon from '@mui/icons-material/LightMode';
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation';
import LocationOnSharpIcon from '@mui/icons-material/LocationOnSharp';
import LockIcon from '@mui/icons-material/Lock';
import LockResetIcon from '@mui/icons-material/LockReset';
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';
import MenuIcon from '@mui/icons-material/Menu';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import OutputIcon from '@mui/icons-material/Output';
import PaletteIcon from '@mui/icons-material/Palette';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import PersonIcon from '@mui/icons-material/Person';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import PhonelinkEraseIcon from '@mui/icons-material/PhonelinkErase';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import PlagiarismIcon from '@mui/icons-material/Plagiarism';
import PlaylistAddCircleIcon from '@mui/icons-material/PlaylistAddCircle';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import PreviewIcon from '@mui/icons-material/Preview';
import PublicIcon from '@mui/icons-material/Public';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import RemoveRoadIcon from '@mui/icons-material/RemoveRoad';
import ResetTvIcon from '@mui/icons-material/ResetTv';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import ScaleIcon from '@mui/icons-material/Scale';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import SendIcon from '@mui/icons-material/Send';
import SendTimeExtensionIcon from '@mui/icons-material/SendTimeExtension';
import SendToMobileIcon from '@mui/icons-material/SendToMobile';
import SettingsIcon from '@mui/icons-material/Settings';
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';
import SmartButtonIcon from '@mui/icons-material/SmartButton';
import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard';
import StarSharpIcon from '@mui/icons-material/StarSharp';
import SummarizeIcon from '@mui/icons-material/Summarize';
import TableChartIcon from '@mui/icons-material/TableChart';
import TodayIcon from '@mui/icons-material/Today';
import VerticalAlignBottomIcon from '@mui/icons-material/VerticalAlignBottom';
import VerticalAlignTopIcon from '@mui/icons-material/VerticalAlignTop';
import ViewSidebarIcon from '@mui/icons-material/ViewSidebar';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import WarningIcon from '@mui/icons-material/Warning';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import { CircularProgress, SvgIconProps } from '@mui/material';
import React from 'react';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import SearchIcon from '@mui/icons-material/Search';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import ListAltIcon from '@mui/icons-material/ListAlt';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddIcon from '@mui/icons-material/Add';
import HistoryIcon from '@mui/icons-material/History';
import FileOpenIcon from '@mui/icons-material/FileOpen';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import CancelIcon from '@mui/icons-material/Cancel';
import BackupIcon from '@mui/icons-material/Backup';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import PostAddIcon from '@mui/icons-material/PostAdd';
import GroupIcon from '@mui/icons-material/Group';
import RemoveIcon from '@mui/icons-material/Remove';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import TransferWithinAStationIcon from '@mui/icons-material/TransferWithinAStation';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import PrintIcon from '@mui/icons-material/Print';
import ArchiveIcon from '@mui/icons-material/Archive';
import UnarchiveIcon from '@mui/icons-material/Unarchive';
import InsertPhotoIcon from '@mui/icons-material/InsertPhoto';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import HandshakeIcon from '@mui/icons-material/Handshake';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import LandscapeIcon from '@mui/icons-material/Landscape';
import PriceChangeIcon from '@mui/icons-material/PriceChange';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import PlaceIcon from '@mui/icons-material/Place';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import NotesIcon from '@mui/icons-material/Notes';

const iconMap = {
    addCircle: AddCircleIcon,
    deleteForever: DeleteForeverIcon,
    calendarMonth: CalendarMonthIcon,
    settingsBackupRestore: SettingsBackupRestoreIcon,
    arrowForward: ArrowForwardIcon,
    arrowBack: ArrowBackIcon,
    sendToMobile: SendToMobileIcon,
    warning: WarningIcon,
    eventRepeat: EventRepeatIcon,
    accessTime: AccessTimeIcon,
    edit: EditIcon,
    delete: DeleteIcon,
    menu: MenuIcon,
    visibility: VisibilityIcon,
    visibilityOff: VisibilityOffIcon,
    fileDownload: FileDownloadIcon,
    logout: LogoutIcon,
    lock: LockIcon,
    close: CloseIcon,
    output: OutputIcon,
    peopleAlt: PeopleAltIcon,
    precisionManufacturing: PrecisionManufacturingIcon,
    phonelinkErase: PhonelinkEraseIcon,
    resetTv: ResetTvIcon,
    addToHomeScreen: AddToHomeScreenIcon,
    verticalAlignTop: VerticalAlignTopIcon,
    verticalAlignBottom: VerticalAlignBottomIcon,
    palette: PaletteIcon,
    starSharp: StarSharpIcon,
    arrowLeftSharp: ArrowLeftSharpIcon,
    arrowRightSharp: ArrowRightSharpIcon,
    locationOnSharp: LocationOnSharpIcon,
    infoSharp: InfoSharpIcon,
    keyboardArrowDownSharp: KeyboardArrowDownSharpIcon,
    keyboardArrowRightSharp: KeyboardArrowRightSharpIcon,
    help: HelpIcon,
    login: LoginIcon,
    badge: BadgeIcon,
    pictureAsPdf: PictureAsPdfIcon,
    email: EmailIcon,
    searchOff: SearchOffIcon,
    doNotDisturb: DoNotDisturbIcon,
    image: ImageIcon,
    autoMode: AutoModeIcon,
    lockReset: LockResetIcon,
    playListAddCircle: PlaylistAddCircleIcon,
    today: TodayIcon,
    calendarToday: CalendarTodayIcon,
    chevronRight: ChevronRightIcon,
    viewSideBar: ViewSidebarIcon,
    localGasStation: LocalGasStationIcon,
    editCalendar: EditCalendarIcon,
    summarize: SummarizeIcon,
    airportShuttle: AirportShuttleIcon,
    construction: ConstructionIcon,
    adminPanelSettings: AdminPanelSettingsIcon,
    business: BusinessIcon,
    analytics: AnalyticsIcon,
    devicesFold: DevicesFoldIcon,
    sendTimeExtension: SendTimeExtensionIcon,
    plagiarism: PlagiarismIcon,
    equalizer: EqualizerIcon,
    preview: PreviewIcon,
    euro: EuroIcon,
    freeCancellation: FreeCancellationIcon,
    done: DoneIcon,
    doneAll: DoneAllIcon,
    publishedWithChanges: PublishedWithChangesIcon,
    send: SendIcon,
    monetizationOn: MonetizationOnIcon,
    restartAlt: RestartAltIcon,
    wifiOff: WifiOffIcon,
    contentCopy: ContentCopyIcon,
    settings: SettingsIcon,
    addRoad: AddRoadIcon,
    editRoad: EditRoadIcon,
    removeRoad: RemoveRoadIcon,
    tableChart: TableChartIcon,
    event: EventIcon,
    smartButton: SmartButtonIcon,
    editNote: EditNoteIcon,
    spaceDashboard: SpaceDashboardIcon,
    public: PublicIcon,
    personOff: PersonOffIcon,
    person: PersonIcon,
    scale: ScaleIcon,
    lightMode: LightModeIcon,
    darkMode: DarkModeIcon,
    arrowCircleLeft: ArrowCircleLeftIcon,
    arrowCircleRight: ArrowCircleRightIcon,
    search: SearchIcon,
    arrowUpward: ArrowUpwardIcon,
    arrowDownward: ArrowDownwardIcon,
    importExport: ImportExportIcon,
    listAlt: ListAltIcon,
    moreVert: MoreVertIcon,
    add: AddIcon,
    history: HistoryIcon,
    fileOpen: FileOpenIcon,
    dragIndicator: DragIndicatorIcon,
    cancel: CancelIcon,
    backup: BackupIcon,
    insertDriveFile: InsertDriveFileIcon,
    postAdd: PostAddIcon,
    group: GroupIcon,
    remove: RemoveIcon,
    taskAlt: TaskAltIcon,
    transferWithinAStation: TransferWithinAStationIcon,
    lockOpen: LockOpenIcon,
    checkCircleOutline: CheckCircleOutlineIcon,
    personOutline: PersonOutlineIcon,
    navigateNext: NavigateNextIcon,
    print: PrintIcon,
    archive: ArchiveIcon,
    unarchive: UnarchiveIcon,
    insertPhoto: InsertPhotoIcon,
    cloudUpload: CloudUploadIcon,
    cloudDownload: CloudDownloadIcon,
    shoppingCart: ShoppingCartIcon,
    handshake: HandshakeIcon,
    inventory2: Inventory2Icon,
    localShipping: LocalShippingIcon,
    landscape: LandscapeIcon,
    priceChange: PriceChangeIcon,
    factCheck: FactCheckIcon,
    place: PlaceIcon,
    openInNew: OpenInNewIcon,
    notes: NotesIcon,
};

export interface IconProps extends SvgIconProps {
    name: keyof typeof iconMap;
    loading?: boolean;
}

const Icon: React.FC<IconProps> = ({ name, loading = false, ...props }) => {
    const IconComponent = iconMap[name];

    if (!IconComponent) {
        console.warn(`Unknown icon name: ${name}`);
        return null;
    }

    return <>{loading ? <CircularProgress size={20} color="inherit" /> : <IconComponent fontSize="medium" {...props} />}</>;
};

export default Icon;
